import { useState, useCallback } from 'react';
import { dashboard as dashboardApi } from '@/lib/api';
import type { DashboardSummary } from '@/lib/types';

interface UseDashboardReturn {
  summary: DashboardSummary | null;
  loading: boolean;
  error: string | null;
  fetchSummary: () => Promise<void>;
}

export function useDashboard(): UseDashboardReturn {
  const [summary, setSummary] = useState<DashboardSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSummary = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await dashboardApi.getSummary();
      setSummary(data);
    } catch (err) {
      const message =
        err instanceof Error
          ? err.message
          : 'Failed to fetch dashboard summary';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    summary,
    loading,
    error,
    fetchSummary,
  };
}
